import { API_NOT_FOUND, API_SERVER_ERROR } from '../actions'

export class ApiError extends Error {
  constructor(_action, ...error) {
    super(...error)
  }

  static handleError(error) {
    if (error?.response?.status) {
      switch (error.response.status) {
        case 404:
          throw new ApiError({ type: API_NOT_FOUND }, error)
        default:
          throw new ApiError({ type: API_SERVER_ERROR }, error)
      }
    }

    if (error.response && error.response.data) {
      if (error.response.data.response && error.response.data.response.error) {
        throw new Error(error.response.data.response.error)
      }

      if (error.response.data.error) {
        throw new Error(error.response.data.error)
      }

      if (error.response.data.message) {
        throw new Error(error.response.data.message)
      }

      throw new Error(JSON.stringify(error.response.data))
    }

    throw new Error(error)
  }
}
